module.exports = __webpack_public_path__ + "static/Truck7-473748b07341eab42b5d2780dbc841eb.png";